/** Cryptographically secure integer in [0, max). Browser equivalent of Node's crypto.randomInt. */
export const randomInt = (max: number): number => {
  // Reject values above the largest multiple of `max` to avoid modulo bias.
  const limit = Math.floor(0x1_0000_0000 / max) * max
  const buf = new Uint32Array(1)
  do {
    globalThis.crypto.getRandomValues(buf)
  } while (buf[0] >= limit)
  return buf[0] % max
}
